{
	"async_pickers": {
		"selected_count_one": "1 selezionato",
		"selected_count_other": "{{count}} selezionati"
	},
	"data_table": {
		"column_menu": {
			"autosize_column": "Adatta larghezza colonna",
			"clear_sort": "Rimuovi ordinamento",
			"hide_column": "Nascondi colonna",
			"no_pin": "Nessun blocco",
			"pin_column": "Blocca colonna",
			"pin_left": "Blocca a sinistra",
			"pin_right": "Blocca a destra",
			"sort_asc": "Ordina crescente",
			"sort_desc": "Ordina decrescente",
			"trigger": "Opzioni colonna {{column}}"
		},
		"column_settings": {
			"drag_handle": "Riordina colonna",
			"no_results": "Nessuna colonna trovata",
			"pin_column": "Blocca {{column}}",
			"pin_left": "Blocca a sinistra",
			"pin_right": "Blocca a destra",
			"reset": "Ripristina",
			"search_placeholder": "Cerca colonne...",
			"show_all": "Mostra tutte",
			"toggle_visibility": "Mostra/nascondi {{column}}",
			"trigger": "Colonne",
			"unpin": "Sblocca"
		},
		"error": "Caricamento dei dati non riuscito",
		"loading_more": "Caricamento...",
		"no_results": "Nessun risultato",
		"pagination": {
			"go_to_page": "Vai a pagina {{page}}",
			"more_pages": "Altre pagine",
			"next": "Successivo",
			"previous": "Precedente",
			"rows_per_page": "Righe per pagina"
		},
		"select_all": "Seleziona tutte le righe",
		"select_row": "Seleziona riga",
		"sort_by": "Ordina per {{column}}"
	},
	"http_errors": {
		"admin_forbidden": "Non hai i permessi per eseguire questa azione amministrativa.",
		"anonymous_sign_in_disabled": "L'accesso anonimo è disabilitato.",
		"anonymous_user_cannot_change_password": "Gli utenti anonimi non possono modificare la password.",
		"anonymous_users_cannot_sign_in_again_anonymously": "Gli utenti anonimi non possono accedere di nuovo in modo anonimo.",
		"apple_mobile_deep_link_not_allowed": "I link di accesso Apple mobile non sono consentiti.",
		"apple_mobile_ott_invalid": "Il token di accesso Apple mobile non è valido.",
		"apple_mobile_sign_in_failed": "Accesso con Apple mobile non riuscito.",
		"auth_credentials_missing": "Effettua l'accesso prima di continuare.",
		"auth_csrf_invalid": "Il token di sicurezza della sessione non è valido. Ricarica e riprova.",
		"auth_email_not_found": "Nessun account trovato con questo indirizzo email.",
		"auth_jwt_invalid": "La sessione di accesso non è valida o è scaduta. Effettua di nuovo l'accesso.",
		"auth_session_issue_failed": "Non è stato possibile completare l'accesso. Riprova.",
		"auth_token_invalid": "La sessione di accesso non è valida o è scaduta. Ricomincia.",
		"backoffice_admin_deleted": "Questo account amministratore è stato eliminato.",
		"backoffice_admin_disabled": "Questo account amministratore è disabilitato. Contatta un amministratore.",
		"backoffice_admin_not_found": "Account amministratore non trovato.",
		"backoffice_auth_credentials_missing": "Effettua l'accesso come admin prima di continuare.",
		"backoffice_auth_token_invalid": "La sessione di accesso non è valida o è scaduta. Ricomincia.",
		"backoffice_challenge_not_found": "Sfida di autenticazione admin non trovata.",
		"backoffice_change_password_otp_invalid": "Il codice via email non è valido. Riprova.",
		"backoffice_change_password_otp_unavailable": "I codici via email non sono disponibili per modificare questa password admin.",
		"backoffice_change_password_totp_invalid": "Il codice dell'app di autenticazione non è valido. Riprova.",
		"backoffice_csrf_invalid": "Il token di sicurezza della sessione admin non è valido. Ricarica e riprova.",
		"backoffice_disable_two_factor_method_not_available": "Non è disponibile alcun metodo per disabilitare l'autenticazione a due fattori per questo account admin.",
		"backoffice_disable_two_factor_otp_invalid": "Il codice via email non è valido. Riprova.",
		"backoffice_disable_two_factor_otp_unavailable": "I codici via email non sono disponibili per disabilitare l'autenticazione a due fattori per questo account admin.",
		"backoffice_disable_two_factor_passkey_invalid": "Verifica con passkey non riuscita. Riprova.",
		"backoffice_disable_two_factor_recovery_code_invalid": "Il codice di recupero non è valido. Riprova.",
		"backoffice_disable_two_factor_totp_invalid": "Il codice dell'app di autenticazione non è valido. Riprova.",
		"backoffice_email_already_in_use": "Esiste già un account admin con questa email.",
		"backoffice_email_change_token_invalid": "La sessione di modifica dell'email admin non è valida o è scaduta.",
		"backoffice_email_otp_token_invalid": "La sessione di verifica è scaduta. Richiedi un nuovo codice.",
		"backoffice_failed_to_verify_registration": "Impossibile verificare la registrazione della passkey admin.",
		"backoffice_invalid_code": "Il codice non è valido.",
		"backoffice_invalid_email_or_password": "L'email o la password non sono validi.",
		"backoffice_invalid_password": "La password non è valida.",
		"backoffice_invite_invalid": "Questo invito admin non è valido o è scaduto.",
		"backoffice_jwt_invalid": "La sessione admin non è valida o è scaduta. Effettua di nuovo l'accesso.",
		"backoffice_mfa_challenge_invalid": "La sessione di verifica è scaduta. Effettua di nuovo l'accesso.",
		"backoffice_mfa_challenge_required_for_change_password": "Verifica la tua identità prima di modificare questa password admin.",
		"backoffice_mfa_device_limit_reached": "Questo account admin ha raggiunto il limite di dispositivi per l'autenticazione a due fattori.",
		"backoffice_mfa_email_otp_not_available": "I codici di verifica via email non sono disponibili per questo account.",
		"backoffice_mfa_enrollment_expired": "La configurazione dell'autenticazione a due fattori è scaduta. Ricomincia.",
		"backoffice_mfa_invalid_backup_code": "Il codice di backup non è valido. Riprova.",
		"backoffice_mfa_invalid_email_otp": "Il codice via email non è valido. Riprova.",
		"backoffice_mfa_invalid_passkey": "Verifica con passkey non riuscita. Riprova.",
		"backoffice_mfa_invalid_totp_code": "Il codice dell'app di autenticazione non è valido. Riprova.",
		"backoffice_mfa_not_enabled": "L'autenticazione a due fattori non è abilitata per questo account admin.",
		"backoffice_mfa_passkey_not_available": "La verifica con passkey non è disponibile per questo account admin.",
		"backoffice_new_email_same_as_current": "La nuova email admin corrisponde a quella attuale.",
		"backoffice_no_change_password_method_available": "Non è disponibile alcun metodo per modificare questa password admin.",
		"backoffice_passkey_authentication_failed": "Autenticazione admin con passkey non riuscita.",
		"backoffice_passkey_limit_reached": "Questo account admin ha raggiunto il limite di passkey.",
		"backoffice_passkey_not_found": "Passkey admin non trovata.",
		"backoffice_rate_limited_one": "Troppi tentativi: riprova tra {{count}} minuto.",
		"backoffice_rate_limited_other": "Troppi tentativi: riprova tra {{count}} minuti.",
		"backoffice_reset_password_session_missing": "La sessione di reimpostazione password amministrativa non è presente.",
		"backoffice_reset_password_token_invalid": "Il token di reimpostazione password amministrativa non è valido o è scaduto.",
		"backoffice_self_edit_forbidden": "Non puoi modificare qui il tuo account admin.",
		"backoffice_session_expired": "La sessione admin è scaduta. Effettua di nuovo l'accesso.",
		"backoffice_session_invalid": "La sessione admin non è più valida. Effettua di nuovo l'accesso.",
		"backoffice_session_issue_failed": "Non è stato possibile completare l'accesso. Riprova.",
		"backoffice_social_not_registered": "Nessun account admin è registrato per questo accesso social.",
		"backoffice_totp_authenticator_not_found": "App di autenticazione admin non trovata.",
		"backoffice_you_are_not_allowed_to_register_this_passkey": "Non sei autorizzato a registrare questa passkey admin.",
		"challenge_not_found": "Sfida di autenticazione non trovata.",
		"change_password_otp_invalid": "Il codice via email non è valido. Riprova.",
		"change_password_otp_unavailable": "I codici via email non sono disponibili per modificare questa password.",
		"change_password_totp_invalid": "Il codice dell'app di autenticazione non è valido. Riprova.",
		"default": "Ops! Qualcosa è andato storto.",
		"disable_two_factor_method_not_available": "Non è disponibile alcun metodo per disabilitare l'autenticazione a due fattori per questo account.",
		"disable_two_factor_otp_invalid": "Il codice via email non è valido. Riprova.",
		"disable_two_factor_otp_unavailable": "I codici via email non sono disponibili per disabilitare l'autenticazione a due fattori per questo account.",
		"disable_two_factor_passkey_invalid": "Verifica con passkey non riuscita. Riprova.",
		"disable_two_factor_recovery_code_invalid": "Il codice di recupero non è valido. Riprova.",
		"disable_two_factor_totp_invalid": "Il codice dell'app di autenticazione non è valido. Riprova.",
		"email_already_in_use": "Esiste già un account con questa email.",
		"email_change_token_invalid": "La sessione di modifica dell'email non è valida o è scaduta.",
		"email_otp_token_invalid": "La sessione di verifica è scaduta. Richiedi un nuovo codice.",
		"export_not_found": "Export non trovato.",
		"export_too_large_for_sync": "Questo export è troppo grande per il download diretto. Usa auto o email quando pronto.",
		"failed_to_verify_registration": "Impossibile verificare la registrazione.",
		"impersonation_token_invalid": "Questo link di impersonificazione non è valido o è già scaduto.",
		"invalid_code": "Il codice non è valido.",
		"invalid_delete_account_otp": "Il codice di eliminazione account non è valido.",
		"invalid_email_or_password": "Email o password non validi.",
		"invalid_password": "La password non è valida.",
		"last_social_account_without_email": "Aggiungi un indirizzo email prima di scollegare l'ultimo account social.",
		"maintenance_mode": "Il servizio è temporaneamente in manutenzione.",
		"mfa_challenge_invalid": "La sessione di verifica è scaduta. Effettua di nuovo l'accesso.",
		"mfa_challenge_required_for_change_password": "Verifica la tua identità prima di modificare la password.",
		"mfa_device_limit_reached": "Questo account ha raggiunto il limite di dispositivi per l'autenticazione a due fattori.",
		"mfa_email_otp_not_available": "I codici di verifica via email non sono disponibili per questo account.",
		"mfa_enrollment_expired": "La configurazione dell'autenticazione a due fattori è scaduta. Ricomincia.",
		"mfa_invalid_backup_code": "Il codice di backup non è valido. Riprova.",
		"mfa_invalid_email_otp": "Il codice via email non è valido. Riprova.",
		"mfa_invalid_passkey": "Verifica con passkey non riuscita. Riprova.",
		"mfa_invalid_totp_code": "Il codice dell'app di autenticazione non è valido. Riprova.",
		"mfa_not_enabled": "L'autenticazione a due fattori non è abilitata per questo account.",
		"mfa_passkey_not_available": "La verifica con passkey non è disponibile per questo account.",
		"mfa_requires_identity": "Verifica la tua identità prima di gestire l'autenticazione a due fattori.",
		"new_email_same_as_current": "La nuova email corrisponde a quella attuale.",
		"no_change_password_method_available": "Non è disponibile alcun metodo per modificare questa password.",
		"otp_issuance_throttled": "Troppe richieste di codice. Attendi prima di richiederne uno nuovo.",
		"passkey_authentication_failed": "Autenticazione con passkey non riuscita.",
		"passkey_limit_reached": "Questo account ha raggiunto il limite di passkey.",
		"passkey_not_found": "Passkey non trovata.",
		"password_too_long": "La password è troppo lunga.",
		"password_too_short": "La password è troppo breve.",
		"permission_denied": "Il tuo account ha effettuato l'accesso, ma non dispone dei permessi necessari per visualizzare questa pagina.",
		"reset_password_session_missing": "La sessione di reimpostazione password non è presente.",
		"reset_password_token_invalid": "Il token di reimpostazione password non è valido o è scaduto.",
		"session_expired": "La sessione è scaduta. Effettua di nuovo l'accesso.",
		"session_invalid": "La sessione non è più valida. Effettua di nuovo l'accesso.",
		"session_not_found": "Sessione non trovata.",
		"social_account_already_linked": "Questo account social è già collegato.",
		"social_code_exchange_failed": "Impossibile completare l'accesso social. Riprova.",
		"social_email_not_verified": "L'indirizzo email dell'account social non è verificato.",
		"social_provider_not_configured": "Questo provider di accesso social non è configurato.",
		"social_redirect_uri_not_allowed": "Questo redirect dell'accesso social non è consentito.",
		"social_token_invalid": "Il token di accesso social non è valido o è scaduto.",
		"totp_authenticator_not_found": "App di autenticazione non trovata.",
		"unauthorized": "Non hai effettuato l'accesso. Effettua l'accesso per continuare.",
		"user_already_has_provider_linked": "Questo utente ha già quel provider collegato.",
		"user_banned": "Questo account utente è stato bannato.",
		"user_deleted": "Questo account utente è stato eliminato.",
		"user_not_found": "Utente non trovato.",
		"validation_error": "Alcuni dei dati inseriti non sono validi.",
		"you_are_not_allowed_to_register_this_passkey": "Non sei autorizzato a registrare questa passkey."
	},
	"inline_filters": {
		"clear": "Rimuovi filtro",
		"clear_all": "Rimuovi tutto"
	},
	"input_password": {
		"hide": "Nascondi password",
		"show": "Mostra password"
	},
	"list_input_search": {
		"clear": "Cancella ricerca",
		"label": "Cerca"
	},
	"query_breadcrumbs": {
		"error": "Errore",
		"no_data": "Dettaglio"
	},
	"sidebar": {
		"close": "Chiudi menu",
		"open": "Apri menu"
	},
	"two_factor_device_picker": {
		"device_label": "Dispositivo authenticator",
		"device_unnamed": "Dispositivo senza nome"
	}
}
